import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Error404 from 'components/theme/Error404';
import Dashboard from './Dashboard';
import Edit from './Edit';
import ChangePassword from './ChangePassword';
import Detail from './Detail';

const User = ( { match } ) => (
  <Switch>
    <Route path={`${match.url}/new`} component={Edit} />
    <Route path={`${match.url}/edit/:id`} component={Edit} />
    <Route path={`${match.url}/detail/:id`} component={Detail} />
    <Route path={`${match.url}/change-password/:id`} component={ChangePassword} />
    <Route path={match.url} component={Dashboard} exact />
    <Route component={Error404} />
  </Switch>
);

export default User;
